import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceByIdController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceByIdController.php
* @route '/api/place/{place_id}'
*/
const GetWikiPlaceByIdController = (args: { place_id: string | number } | [place_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceByIdController.url(args, options),
    method: 'get',
})

GetWikiPlaceByIdController.definition = {
    methods: ["get","head"],
    url: '/api/place/{place_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceByIdController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceByIdController.php
* @route '/api/place/{place_id}'
*/
GetWikiPlaceByIdController.url = (args: { place_id: string | number } | [place_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            place_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place_id: args.place_id,
    }

    return GetWikiPlaceByIdController.definition.url
            .replace('{place_id}', parsedArgs.place_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceByIdController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceByIdController.php
* @route '/api/place/{place_id}'
*/
GetWikiPlaceByIdController.get = (args: { place_id: string | number } | [place_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceByIdController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceByIdController.php
* @route '/api/place/{place_id}'
*/
GetWikiPlaceByIdController.head = (args: { place_id: string | number } | [place_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiPlaceByIdController.url(args, options),
    method: 'head',
})

export default GetWikiPlaceByIdController